import type { ChartColorKey } from '@/lib/chart-colors';

/**
 * Global SVG gradient definitions for charts.
 * Rendered once at app root so any chart can reference url(#area-gradient-chart-1) etc.
 */
export function GlobalChartGradients() {
  return (
    <svg
      aria-hidden="true"
      style={{ position: 'absolute', width: 0, height: 0 }}
    >
      <defs>
        {([1, 2, 3] as ChartColorKey[]).map((key) => (
          <linearGradient
            key={key}
            id={`area-gradient-chart-${key}`}
            x1="0"
            y1="0"
            x2="0"
            y2="1"
          >
            <stop
              offset="5%"
              stopColor={`hsl(var(--chart-${key}))`}
              stopOpacity={0.8}
            />
            <stop
              offset="95%"
              stopColor={`hsl(var(--chart-${key}))`}
              stopOpacity={0.1}
            />
          </linearGradient>
        ))}
        {/* Legacy ids — alias chart-1 gradient for existing references during migration */}
        <linearGradient id="blueGradient" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="hsl(var(--chart-1))" stopOpacity={0.8} />
          <stop
            offset="95%"
            stopColor="hsl(var(--chart-1))"
            stopOpacity={0.1}
          />
        </linearGradient>
        <linearGradient id="whiteGradient" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="hsl(var(--chart-1))" stopOpacity={0.8} />
          <stop
            offset="95%"
            stopColor="hsl(var(--chart-1))"
            stopOpacity={0.1}
          />
        </linearGradient>
      </defs>
    </svg>
  );
}
